module.exports = __webpack_public_path__ + "static/img/success.6e0b5feb.png";